import { render, staticRenderFns } from "./FactList.vue?vue&type=template&id=1847a5ed&functional=true"
import script from "./FactList.vue?vue&type=script&lang=js"
export * from "./FactList.vue?vue&type=script&lang=js"
import style0 from "./FactList.vue?vue&type=style&index=0&id=1847a5ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports